var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResync({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4393 3L2.25 3C1.00736 3 -5.89781e-07 4.00736 -5.35464e-07 5.25L-3.16908e-07 10.25C-2.98802e-07 10.6642 0.335787 11 0.75 11C1.16421 11 1.5 10.6642 1.5 10.25L1.5 5.25C1.5 4.83579 1.83579 4.5 2.25 4.5L11.4393 4.5L10.2197 5.71967C9.92678 6.01256 9.92678 6.48744 10.2197 6.78033C10.5126 7.07322 10.9874 7.07322 11.2803 6.78033L13.7803 4.28033C14.0732 3.98744 14.0732 3.51256 13.7803 3.21967L11.2803 0.719669C10.9874 0.426776 10.5126 0.426776 10.2197 0.719669C9.92678 1.01256 9.92678 1.48744 10.2197 1.78033L11.4393 3ZM2.71967 17.2803C3.01256 17.5732 3.48744 17.5732 3.78033 17.2803C4.07322 16.9874 4.07322 16.5126 3.78033 16.2197L2.56066 15L11.75 15C12.9926 15 14 13.9926 14 12.75L14 7.75C14 7.33579 13.6642 7 13.25 7C12.8358 7 12.5 7.33579 12.5 7.75L12.5 12.75C12.5 13.1642 12.1642 13.5 11.75 13.5L2.56066 13.5L3.78033 12.2803C4.07322 11.9874 4.07322 11.5126 3.78033 11.2197C3.48744 10.9268 3.01256 10.9268 2.71967 11.2197L0.21967 13.7197C-0.0732232 14.0126 -0.0732231 14.4874 0.21967 14.7803L2.71967 17.2803Z",
    fill: "#3AAD2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResync);
export default __webpack_public_path__ + "static/media/resync.e0ad7f51ae295316645223eeb83392fa.svg";
export { ForwardRef as ReactComponent };